var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnsIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.3972 0H6.60283C2.95619 0 0 2.95619 0 6.60283V23.3972C0 27.0438 2.95619 30 6.60283 30H23.3972C27.0438 30 30 27.0438 30 23.3972V6.60283C30 2.95619 27.0438 0 23.3972 0Z",
    fill: "url(#paint0_linear_24_3411)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.3972 0.000244141H6.60283C2.95619 0.000244141 0 2.95643 0 6.60308V23.3974C0 27.0441 2.95619 30.0002 6.60283 30.0002H23.3972C27.0438 30.0002 30 27.0441 30 23.3974V6.60308C30 2.95643 27.0438 0.000244141 23.3972 0.000244141Z",
    fill: "url(#paint1_radial_24_3411)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.634 26.0795H10.3666C6.81262 26.0795 3.9209 23.1878 3.9209 19.6338V10.3664C3.9209 6.81238 6.81262 3.92065 10.3666 3.92065H19.634C23.188 3.92065 26.0797 6.81238 26.0797 10.3664V19.6338C26.0797 23.1878 23.188 26.0795 19.634 26.0795ZM10.3666 5.85668C7.87998 5.85668 5.85693 7.87974 5.85693 10.3664V19.6338C5.85693 22.1204 7.87998 24.1435 10.3666 24.1435H19.634C22.1207 24.1435 24.1437 22.1204 24.1437 19.6338V10.3664C24.1437 7.87974 22.1207 5.85668 19.634 5.85668H10.3666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.0001 20.6655C11.8758 20.6655 9.33447 18.1242 9.33447 14.9999C9.33447 11.8756 11.8758 9.33429 15.0001 9.33429C18.1244 9.33429 20.6657 11.8756 20.6657 14.9999C20.6657 18.1242 18.1244 20.6655 15.0001 20.6655ZM15.0001 11.2695C12.9432 11.2695 11.2705 12.943 11.2705 14.9991C11.2705 17.0553 12.9439 18.7287 15.0001 18.7287C17.0563 18.7287 18.7297 17.0553 18.7297 14.9991C18.7297 12.943 17.0563 11.2695 15.0001 11.2695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.0717 9.79848C22.4643 9.16319 22.2676 8.32986 21.6323 7.93719C20.9971 7.54452 20.1637 7.7412 19.7711 8.3765C19.3784 9.01179 19.5751 9.84512 20.2104 10.2378C20.8457 10.6305 21.679 10.4338 22.0717 9.79848Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24_3411",
    x1: 8.9347,
    y1: -0.31035,
    x2: 21.8423,
    y2: 32.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4960C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#9434C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#9A34BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#B136B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C137A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#CA389F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CE399E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D13A97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#D93F86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#DE427D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0437A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_24_3411",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.55196 29.3757) scale(26.7201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFD754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FFAE4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF8A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FF7043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F54F4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F14D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F04C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#EB4960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#EA4963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#E74767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E14376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0437A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsIg);
export default __webpack_public_path__ + "static/media/sns_ig.5022cb2e5e7bb82c4dabe7a959bf3a26.svg";
export { ForwardRef as ReactComponent };